var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.warrantiesOpt(),"size":"sm"},model:{value:(_vm.provinceProduct.warranty_codice),callback:function ($$v) {_vm.$set(_vm.provinceProduct, "warranty_codice", $$v)},expression:"provinceProduct.warranty_codice"}})
}
var staticRenderFns = []

export { render, staticRenderFns }